import React from 'react';
import ContentLoader from 'react-content-loader';
import InputMask from 'react-input-mask';
import { useHistory, withRouter } from 'react-router-dom';
import { Button, Card, Grid, Page, Form, FormTextInput } from 'tabler-react';

import PrivatePage from './PrivatePage';
import { Backend } from '../services';

function ProjectAccreditationPage(props) {
  const projectId = props.match.params.projectId;

  const history = useHistory();
  const [groups, setGroups] = React.useState(null);
  const [selectedProjects, setSelectedProjects] = React.useState({
    [projectId]: true
  });
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [mobilePhone, setMobilePhone] = React.useState('');
  const [creci, setCreci] = React.useState('');
  const [tshirtSize, setTshirtSize] = React.useState('');
  const [realState, setRealState] = React.useState('');
  const [realStateDocument, setRealStateDocument] = React.useState('');
  const [realStateCreci, setRealStateCreci] = React.useState('');
  const [realStateResponsibleName, setRealStateResponsibleName] = React.useState('');
  const [realStateResponsibleMobilePhone, setRealStateResponsibleMobilePhone] = React.useState('');
  const [realStateResponsibleEmail, setRealStateResponsibleEmail] = React.useState('');
  const [errors, setErrors] = React.useState(null);
  const [submitting, setSubmitting] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const resProjects = await Backend.listProjects();
        const newGroups = resProjects.data.rows.reduce((obj, row) => {
          if (!obj[row.group]) obj[row.group] = { group: row.group, projects: [] };
          
          obj[row.group].projects.push(row);

          return obj;
        }, {});
        setGroups(Object.keys(newGroups).map(k => newGroups[k]));

        const res = await Backend.getProfile();
        setName(res.data.name);
        setEmail(res.data.email);
        setMobilePhone(res.data.mobilePhone);
        setCreci(res.data.creci);
        setTshirtSize(res.data.tshirtSize);
        setRealState(res.data.realState);
        setRealStateDocument(res.data.realStateDocument);
        setRealStateCreci(res.data.realStateCreci);
        setRealStateResponsibleName(res.data.realStateResponsibleName);
        setRealStateResponsibleMobilePhone(res.data.realStateResponsibleMobilePhone);
        setRealStateResponsibleEmail(res.data.realStateResponsibleEmail);

        setLoading(false);
      } catch (err) {
        console.error(err);
        alert('Something went wrong');
      }

      setLoading(false);
    })();
  }, []);

  const validSelectedProjects = () => 
    Object.keys(selectedProjects).filter(p => selectedProjects[p])
  
  const onSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);
    setErrors(null);

    try {
      await Backend.createAccreditation({
        projects: validSelectedProjects(),
        name,
        email,
        mobilePhone,
        creci,
        tshirtSize,
        realState,
        realStateDocument,
        realStateCreci,
        realStateResponsibleName,
        realStateResponsibleMobilePhone,
        realStateResponsibleEmail,
      });

      alert('Parabéns agora você poderá acessar os empreendimentos credenciados')

      return history.replace('/projects');
    } catch (err) {
      setSubmitting(false);

      if (err.response.status === 400) {
        const fields = err.response.data.reduce((obj, i) => {
          obj[i.field] = i.message;
          return obj;
        }, {});

        return setErrors(fields);
      }

      console.log(err.response);
      alert('Something went wrong');
    }
  };

  return (
    <PrivatePage>
      {
        loading ? <Page.Content><ContentLoader foregroundColor="#DDD"/></Page.Content>
        :
        <Page.Content>
          <Page.Header title="Credenciamento" subTitle="Preencha o formulário abaixo para se credenciar aos empreendimentos"/>
          <Form className="card" onSubmit={onSubmit}>
            <Card.Body className="p-6">
              <Grid>
                <Grid.Row>
                  <Grid.Col sm="12" lg="6">
                    <FormTextInput
                      name="name"
                      label="Nome"
                      onChange={(e) => {setName(e.target.value)}}
                      value={name}
                      error={errors && errors.name}
                    />

                    <FormTextInput
                      name="email"
                      label="Email"
                      onChange={(e) => {setEmail(e.target.value)}}
                      value={email}
                      error={errors && errors.email}
                    />

                    <InputMask mask="(99) 99999-9999" value={mobilePhone} onChange={(e) => {setMobilePhone(e.target.value)}}>
                      {(inputProps) => 
                        <FormTextInput
                          {...inputProps}
                          name="mobilePhone"
                          label="Celular"
                          error={errors && errors.mobilePhone}
                        />
                      }
                    </InputMask>

                    <FormTextInput
                      name="creci"
                      label="CRECI"
                      onChange={(e) => {setCreci(e.target.value)}}
                      value={creci}
                      error={errors && errors.creci}
                    />

                    <Form.Group label="Tamanho da camiseta">
                      <Form.Select name="tshirtSize" onChange={(e) => {setTshirtSize(e.target.value)}}>
                        <option value="PP" selected={tshirtSize === 'PP'}>PP</option>
                        <option value="P" selected={tshirtSize === 'P'}>P</option>
                        <option value="M" selected={tshirtSize === 'M'}>M</option>
                        <option value="G" selected={tshirtSize === 'G'}>G</option>
                        <option value="GG" selected={tshirtSize === 'GG'}>GG</option>
                      </Form.Select>
                    </Form.Group>

                    <FormTextInput
                      name="realState"
                      label="Nome da Imobiliária"
                      onChange={(e) => {setRealState(e.target.value)}}
                      value={realState}
                      error={errors && errors.realState}
                    />

                    <FormTextInput
                      name="realStateDocument"
                      label="CNPJ da Imobiliária"
                      onChange={(e) => {setRealStateDocument(e.target.value)}}
                      value={realStateDocument}
                      error={errors && errors.realStateDocument}
                    />

                    <FormTextInput
                      name="realStateCreci"
                      label="CRECI da Imobiliária"
                      onChange={(e) => {setRealStateCreci(e.target.value)}}
                      value={realStateCreci}
                      error={errors && errors.realStateCreci}
                    />

                    <FormTextInput
                      name="realStateResponsibleName"
                      label="Nome do responsável pela Imobiliária"
                      onChange={(e) => {setRealStateResponsibleName(e.target.value)}}
                      value={realStateResponsibleName}
                      error={errors && errors.realStateResponsibleName}
                    />

                    <InputMask mask="(99) 99999-9999" value={realStateResponsibleMobilePhone} onChange={(e) => {setRealStateResponsibleMobilePhone(e.target.value)}}>
                      {(inputProps) => 
                        <FormTextInput
                          {...inputProps}
                          name="realStateResponsibleMobilePhone"
                          label="Celular do responsável pela Imobiliária"
                          error={errors && errors.realStateResponsibleMobilePhone}
                        />
                      }
                    </InputMask>

                    <FormTextInput
                      name="realStateResponsibleEmail"
                      label="Email do responsável pela Imobiliária"
                      onChange={(e) => {setRealStateResponsibleEmail(e.target.value)}}
                      value={realStateResponsibleEmail}
                      error={errors && errors.realStateResponsibleEmail}
                    />

                  </Grid.Col>

                  <Grid.Col sm="12" lg="6">
                    <Form.Group label="Empreendimentos">
                    {
                      groups.map(group => (
                        <div className="py-2" key={group.group}>
                          <p><strong>{group.group}</strong></p>
                          
                          {   
                            group.projects.map(project => (
                              <Form.Checkbox
                                disabled={project.accredited}
                                checked={selectedProjects[project.id] || project.accredited}
                                label={project.name}
                                value="true"
                                onChange={(e) => setSelectedProjects({...selectedProjects, ...{[project.id]: e.target.checked}})}
                              />
                            ))
                          }
                        </div>
                      ))
                    }
                    </Form.Group>
                  </Grid.Col>
                </Grid.Row>
              </Grid>
            

              <Form.Footer>
                <Button loading={submitting} type="submit" color="primary" block>Credenciar</Button>
              </Form.Footer> 
            </Card.Body>
          </Form>
        </Page.Content>
      }
    </PrivatePage>
  )
}

export default withRouter(ProjectAccreditationPage);